import React from "react";
import { Route } from "lucide-react";

/**
 * Renders the full traceability trail as a footer watermark at the bottom
 * of a document detail page (Indent, PR, PO, GRN, Invoice, PV).
 *
 * Example: `PV-2026-0003 / INV-... / GRN-... / KIPL/PO/... / DPO-... / PR-... / IND-...`
 */
export default function DocumentTrail({ trail, className = "" }) {
  if (!trail) return null;
  return (
    <div
      data-testid="document-trail"
      className={`mt-8 border-t border-border pt-4 ${className}`}
    >
      <div className="flex items-start gap-2 rounded-md bg-secondary/40 border border-border/60 px-4 py-3">
        <Route size={13} className="text-kabir mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">
            Document Trail
          </div>
          <div
            className="font-mono text-[11px] mt-1 text-foreground/80 break-all leading-relaxed"
            data-testid="document-trail-text"
          >
            {trail}
          </div>
        </div>
      </div>
    </div>
  );
}
